import { render, staticRenderFns } from "./TradeHistoryList.vue?vue&type=template&id=38005f5b&scoped=true"
import script from "./TradeHistoryList.vue?vue&type=script&lang=js"
export * from "./TradeHistoryList.vue?vue&type=script&lang=js"
import style0 from "./TradeHistoryList.vue?vue&type=style&index=0&id=38005f5b&prod&scoped=true&lang=css"
import style1 from "../../sass/partials/sidebar-submenu.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38005f5b",
  null
  
)

export default component.exports